import { useStyles } from '@gorila-shared-ui/components';
import React, { useEffect } from 'react';
import { Rnd } from 'react-rnd';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { useWindowSize } from 'usehooks-ts';
import {
  floatingCardsXPositionState,
  rigthCardWidthState,
  sidenavWidthState,
  topCardHeightState,
} from '../../../storage/app';
import { showPlaybackStreamingState } from '../../../storage/streaming';
import { RightCard } from '../../../types/app';

type Props = Readonly<{
  children: React.ReactNode;
  name: string;
  windowHeight?: number;
}>;

function FloatingTopCard({ children, windowHeight, name }: Props) {
  const { css, theme } = useStyles();
  const { width } = useWindowSize();
  const xPosition = useRecoilValue(floatingCardsXPositionState);
  const sidenavWidth = useRecoilValue(sidenavWidthState(false));
  const showingPlayback = useRecoilValue(showPlaybackStreamingState);
  const rightCardWidth = useRecoilValue(
    rigthCardWidthState(showingPlayback ? RightCard.playback : RightCard.streaming),
  );
  const initialWindowWidth = width - xPosition - sidenavWidth - rightCardWidth - (rightCardWidth ? 0 : 34) - 24;
  const windowYPosition = 12;
  const [cardHeight, setCardHeight] = useRecoilState(topCardHeightState(name));
  const resetCardHeight = useResetRecoilState(topCardHeightState(name));

  useEffect(() => {
    return () => {
      resetCardHeight();
    };
  }, []);

  useEffect(() => {
    if (windowHeight) {
      setCardHeight(windowHeight);
    }
  }, [windowHeight]);

  return (
    <Rnd
      default={{
        x: xPosition,
        y: windowYPosition,
        width: initialWindowWidth,
        height: windowHeight || cardHeight,
      }}
      minWidth={initialWindowWidth}
      className={css({
        backgroundColor: '#fff',
        border: '1px solid #E2E2E2',
        borderRadius: theme.sizing.scale500,
        display: 'flex',
        overflow: 'hidden',
        padding: theme.sizing.scale600,
        width: '100%',
      })}
      enableResizing={false}
      bounds="body"
      disableDragging
      position={{
        x: xPosition,
        y: windowYPosition,
      }}
      size={{
        height: cardHeight,
        width: initialWindowWidth,
      }}
    >
      {children}
    </Rnd>
  );
}

export default FloatingTopCard;
